import {
  triggerDefaultViewChangeRequest,
  triggerGameHistoryViewChangeRequest,
  triggerGameRulesViewChangeRequest,
  triggerMainSettingsViewChangeRequest,
  triggerPaytableViewChangeRequest
} from "../../Keypad/Common/Keypad.actions";
import { triggerSettingChangeRequest } from "../../Menu/Common/Menu.actions";

import { IPlayUIStateProps } from "../..";
import { IMenuMapDispatchProps, IMenuMapStateProps } from "./Menu";

export const sharedMapPropsToState = (
  state: IPlayUIStateProps
): IMenuMapStateProps => ({
  view: state.view,
  selectedTab: state.menu.selectedTab,
  gameRulesAvailable: state.menu.gameRulesAvailable,
  gameHistoryEnabled: state.menu.gameHistoryEnabled,
  gameHistoryAvailable: state.menu.gameHistoryAvailable,
  gameRulesContent: state.menu.gameRulesContent,
  gameSettings: state.keypad.gameSettings
});

export const sharedMapDispatchToProps = (dispatch): IMenuMapDispatchProps => ({
  triggerDefaultViewChangeRequest: () =>
    dispatch(triggerDefaultViewChangeRequest()),
  triggerMainSettingsViewChangeRequest: () =>
    dispatch(triggerMainSettingsViewChangeRequest()),
  triggerPaytableViewChangeRequest: () =>
    dispatch(triggerPaytableViewChangeRequest()),
  triggerGameRulesViewChangeRequest: () =>
    dispatch(triggerGameRulesViewChangeRequest()),
  triggerGameHistoryViewChangeRequest: () =>
    dispatch(triggerGameHistoryViewChangeRequest()),
  createTriggerSettingChangeRequest: (
    setting: string,
    preDefinedValue: boolean
  ) => () =>
    dispatch(
      triggerSettingChangeRequest({
        key: setting,
        value: preDefinedValue
      })
    )
});
